import React from 'react';
import axios from 'axios';

class Unsubscribe extends React.Component {
  state = { status: 'loading' }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) { this.setState({ status: 'error' }); return; }
    axios.post('/unsubscribe', { token })
      .then(() => this.setState({ status: 'success' }))
      .catch(() => this.setState({ status: 'error' }));
  }

  render() {
    return (
      <div className="main-container">
        <section className="imageblock switchable feature-large height-100">
          <div className="imageblock__content col-md-6 col-sm-4 pos-right">
            <div className="background-image-holder">
              <img alt="image" src="/login-bg.jpg" />
            </div>
          </div>
          <div className="container pos-vertical-center">
            <div className="row">
              <div className="col-md-5 col-sm-7">
                <img className="logo login-logo" alt="logo" src="/logo.png" />
                {this.state.status === 'loading' && <p>Processing...</p>}
                {this.state.status === 'success' && (
                  <div>
                    <h2>Unsubscribed</h2>
                    <p>You will no longer receive order reminders for this supplier.</p>
                  </div>
                )}
                {this.state.status === 'error' && (
                  <div>
                    <h2>Something went wrong</h2>
                    <p>This unsubscribe link may be invalid. Please contact <a href="mailto:support@orderfresh.com.au">support@orderfresh.com.au</a>.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Unsubscribe;
